import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { usePokerMultiTableTournamentsWidget } from '../../../model';

import { TXTMOB_Games_available } from './AvailableCount.messages.json';
import styles from './AvailableCount.scss';

const AvailableCount = () => {
  const { widgetSelect } = usePokerMultiTableTournamentsWidget();
  const tableRowsCount = useSelector(widgetSelect.getTableRowsCount);

  return (
    <div className={styles.availableCountContainer}>
      <Translation {...TXTMOB_Games_available} />
      &nbsp;
      <span>{tableRowsCount}</span>
    </div>
  );
};

export default AvailableCount;
